import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { VhEventMediator, VhQueryAutoWeb } from 'vhautowebdb';
import { NzMessageService } from 'ng-zorro-antd/message';  
import { FunctionService} from 'vhobjects-service/src/services';

@Component({
  selector: 'atw-map-config',
  templateUrl: './map-config.component.html',
  styleUrls: ['./map-config.component.scss']
})
export class AtwMapConfig  implements OnInit {
  @Input() device: any; // xác định thiết bi mobile, desktop ,....
  @ViewChild('myInput') myInput: ElementRef;
  @Input() visibleConfigMap: boolean = false;
  @Input() config: any;@Input() type: any; // là dữ liệu desktop_config hoặc mobile_config từ database
  @Input() objectChoosing: any = {}; // xác định object frame đang được chọn
  @Input() class: any; // là dữ liệu desktop_class hoặc mobile_portrait_class từ database
  @Input() staticdata: any; // là dữ liệu staticdata từ database
  isVisible = false; // biến check logic hiển thị modal
  isCollapsed: boolean = false; // biến check hiển thị đóng mở menu config
  wrong = false;
  srcInput: any; // biến lưu địa chỉ của input
  initialValueBorder: string =
    'https://cdn.icon-icons.com/icons2/953/PNG/512/straight-horizontal-line_icon-icons.com_74237.png';
  currentViewAll: any = {};
  dataBorder = [
    {
      name: 'solid',
      img_border: 'https://static.thenounproject.com/png/2264019-200.png',
      points: '',
    },
    {
      name: 'dashed',
      img_border: 'https://freesvg.org/img/dotted-line-test-2.png',
      points: '10,10',
    },
    {
      name: 'dotted',
      img_border:
        'https://www.pngarts.com/files/10/Dotted-Line-Download-PNG-Image.png',
      points: '5,5',
    },
  ];
  styles_field = [
    {
      title: 'Điều chỉnh bo góc',
      index: 1,
    },
    {
      title: 'dieu_chinh_vien',
      index: 2,
    },
    {
      title: 'hieu_ung_chuyen_dong',
      index: 3,
    },
    {
      title: 'nang_cao',
      index: 4,
    },
  ];
  placeHolder =
    "<iframe src='https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3919.3565404084443!2d106.64403354997823!3d10.783980792278703!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31752eb12833eeef%3A0x56618ff42132b973!2zMTYxIE5pIFPGsCBIdeG7s25oIExpw6puLCBQaMaw4budbmcgMTAsIFTDom4gQsOsbmgsIFRow6BuaCBwaOG7kSBI4buTIENow60gTWluaCwgVmnhu4d0IE5hbQ!5e0!3m2!1svi!2s!4v1673604389514!5m2!1svi!2s' width='600' height='450' style='border:0;' allowfullscreen='' loading='lazy' referrerpolicy='no-referrer-when-downgrade'></iframe>";
  isViewAll: boolean = false;
  titleMain = 'Bản đồ';
  radioValue = ''; //Biến này dùng để phân biệt kiểu bản đồ người dùng muốn add
  /** Biến lưu cấu hình tự động dịch có đang bật không? Tránh gọi hàm getSetups_byFields quá nhiều lần */
  private isAutoTranslate: boolean;


  constructor(
    public vhQueryAutoWeb: VhQueryAutoWeb,
    private message: NzMessageService,
    public sanitizer: DomSanitizer, 
    private vhEventMediator: VhEventMediator, 
    public functionService: FunctionService,
  ) {  
  }

  ngOnInit(): void {
    this.vhQueryAutoWeb.getSetups_byFields({ type: { $in: ['auto_translate_language'] } })
      .then((res: any) => {
        this.isAutoTranslate = res.find((ele) => ele.type == 'auto_translate_language').auto_translate_language;
      });
    if (this.staticdata.local != '') {
      this.radioValue = 'location';
    } else {
      this.radioValue = 'iframe'
    }

    this.srcInput = this.staticdata.iframe;
  }

  ngOnChanges() {
    if (!this.staticdata.accessibility) this.staticdata.accessibility = {};
  }

  //Check open modal
  showModal(): void {
    this.isVisible = true;
  }
  // Check close modal
  handleCancel(): void {
    this.isVisible = false;
  }

  // Hàm này sẽ tạo thông báo , lỗi , thành công , cảnh báo
  createMessage(info: any, type: 'error' | 'success' | 'warning' | 'info' = 'error'): void {
    switch (type) {
      case 'error':
        this.message.error(info);
        break;
      case 'success':
        this.message.success(info);
        break;
      case 'warning':
        this.message.warning(info);
        break;
      case 'info':
        this.message.info(info);
        break;
      default:
        this.message.error(info);
    }
  }

  // //Hàm update class
  updateClass() {
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id,
      { [this.device + '_class']: this.class })
      .then((bool: any) => {
      })
  }
 
  /**
   * Cập nhật staticdata vào database.
   */
  updateStaticData() {
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { staticdata: this.staticdata })
      .then((bool) => {
      });
  }

  // Khi chọn add link bằng iframe hàm này sẽ cập nhật
  getLink(link: any) {
    try {
      const linkSplit = link.split(/(https.*?")/).filter(Boolean);
      const srcVideo = linkSplit[1].replace('"', '');
      const regex = /^https:\/\/www\.google\.com\/maps\/embed\?pb=.+$/;
      const videoId = srcVideo.match(regex);
      if (link.includes('iframe') && link.includes('map') && videoId) {
        this.objectChoosing.staticdata.local = "";
        this.objectChoosing.staticdata.src = srcVideo;
        this.objectChoosing.staticdata.default = true;
        this.objectChoosing.staticdata.iframe = link;
        this.createMessage('Cập nhật đường dẫn bản đồ thành công', 'success')

        this.vhEventMediator.notifyOnConfigChanged({
          id: this.objectChoosing._id,
          updateIframe: true,
        });

      } else {
        this.createMessage(
          'Đường dẫn sai, vui lòng đọc hướng dẫn chèn bản đồ để lấy đường dẫn đúng', 'error'
        );
      }
      this.updateStaticData();
    } catch (error) {
      this.createMessage('Vui lòng làm theo hướng dẫn, để lấy được đường dẫn chính xác');
    }
  }
  // Khi chọn add link bằng địa chỉ hàm này sẽ được gọi ra

  getLocal(local: any) {
    // Đầu tiên sẽ xóa khoảng trắng thừa của chuỗi (vd : 1   6    1  N i Sư Huỳnh L iên => 161NiSưHuỳnhLiên)
    local = local.replace(/\s/g, '');
    if (local.length > 0) {
      this.objectChoosing.staticdata.src = this.getGoogleMapsUrl(local)
      this.objectChoosing.staticdata.default = true;
      this.objectChoosing.staticdata.local = local
      this.updateStaticData();
    } else {
      this.createMessage('Vị trí không được để trống hoặc dùng cách nhúng bản đồ nếu không đúng vị trí');
    }

  }
  // hàm này sẽ chuyển địa chỉ thành chuỗi url
  getGoogleMapsUrl(place: string) {

    const query = {
      q: place
    };

    const url = 'https://www.google.com/maps?' + this.encodeQueryData(query);

    return url + "&output=embed"

  }

  // Hàm này sẽ mã hóa chuỗi url địa chỉ
  encodeQueryData(data: any) {
    return Object.keys(data)
      .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(data[key]))
      .join('&');
  }



  openViewAll(field_text) {
    this.currentViewAll = field_text;
    this.isViewAll = !this.isViewAll;
  }




  /**
   * Hàm này dùng để cho phép mở menu config .
   * Khi mở ở vị trí menu[0] thì các menu khác (menu[n]) đóng lại.
   * @param: value
   */
  openMap: { [name: string]: boolean } = {
    menu1: true,
    menu2: false,
    menu3: false
  };

  openHandler(value: string): void {
    for (const key in this.openMap) {
      if (key !== value) {
        this.openMap[key] = false;
      }
    }
  }
  handleRequired(value) {
    this.config['required'] = value;
  }
  /**
   * hàm này nhận sk thay đổi width height từ component app-width-height-config truyền về
   * @param event width hieght của element sau khi thay đổi
   */
  changeWidthHeight(event) {
    if (event.width) this.class['map']['width'] = event.width + 'px';
    if (event.height) this.class['map']['height'] = event.height + 'px';
    this.vhEventMediator.notifyOnConfigChanged({ status: 'update-object-selected-ruler', code: this.objectChoosing._id });
    this.updateClass()
  }

  /**
   * Update nội dung 
   * @param fieldContent - Tên trường để cập nhật nội dung
   * @param isAriaLabel - Có phải là trường dạng aria-label không
   * @example
   * data = [ { langCode: 'vi', translatedText: 'Bản đồ Việt Nam' } ]
   */
  updateContent(fieldContent, isAriaLabel = false) {
    if (this.isAutoTranslate) {
      this.functionService.translateToMultipleLanguages(
        isAriaLabel 
        ? this.staticdata.accessibility?.[`${fieldContent}_${this.functionService.selectedLanguageCode}`]
        : this.staticdata[`${fieldContent}_${this.functionService.selectedLanguageCode}`]
      )
      .subscribe({
        next: (data) => {
          // console.log('data', data)
          this.functionService.multi_languages.forEach(lang => {
            // Trường hợp là content nằm trong staticdata và nằm bằng cấp với accessibility
            if (!isAriaLabel) {
              if (
                this.functionService.selectedLanguageCode != lang.code 
                && !this.staticdata[`${fieldContent}_${lang.code}`]
              ) {
                this.staticdata[`${fieldContent}_${lang.code}`] = data.find(
                  item => item.langCode == lang.code
                ).translatedText;
              }
            } 
            // Trường hợp là field nằm trong accessibility
            else {
              if (
                this.functionService.selectedLanguageCode != lang.code 
                && !this.staticdata.accessibility?.[`${fieldContent}_${lang.code}`]
              ) {
                this.staticdata.accessibility[`${fieldContent}_${lang.code}`] = data.find(
                  item => item.langCode == lang.code
                ).translatedText;
              }
            }
          });
          this.updateStaticData();
        },
        error: (err) => {
          console.error('Lỗi dịch thuật:', err);
        }
      });
    } else {
      this.updateStaticData();
    }
  }
}
